import React from 'react';

import { BalaklavaIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../../types';

type FacecoverV1Event = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    facecover_score?: number;
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
  };
};

export function FacecoverV1Details({ event }: { event: FacecoverV1Event }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.facecover_score);
  const detection = event.event.overview?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionSettingsLabel={t('videoAnalytics:facecoverAnalyticDetails.workspace.detection switch.label')}
      detectionType="bbox"
      event={event}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<BalaklavaIcon />}
          kind="neutral"
          size="large"
          value={`${t('videoAnalytics:facecoverAnalyticDetails.workspace.tag.label')} ${score}%`}
        />
      )}
      title={t('videoAnalytics:facecoverAnalyticDetails.workspace.title')}
    />
  );
}
